var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showToast)?_c('div',{staticClass:"u-toast"},[_c('div',{staticClass:"content"},[_c('span',{class:['icon', _vm.type]},[_vm._v("!")]),_c('span',{class:['text', _vm.type]},[_vm._v(_vm._s(_vm.text))])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }